import React, { useCallback, useState } from 'react'
import { JSONFetcher, TrustedHtml, useJsonApi } from 'shared'
import { NotificationListProps, NotificationObj, NotificationsList } from './types'

export const NotificationList = ({ apiUrl, emptyMessage }: NotificationListProps): JSX.Element => {
  const { data } = useJsonApi<NotificationsList>(apiUrl)
  const [dismissedCount, setDismissedCount] = useState(0)

  const incrementDismissCount = useCallback(() => {
    setDismissedCount((count) => count + 1)
  }, [])

  if (!data || data.length === dismissedCount) return <span className="block text-gray-700 italic">{emptyMessage}</span>
  return (
    <>
      {data.map((notification, index) => (
        <Notification key={index} dismissCallback={incrementDismissCount} {...notification} />
      ))}
    </>
  )
}

const Notification = ({
  dismissCallback,
  message,
  ctaText,
  ctaPath,
  dismissPath,
}: NotificationObj & { dismissCallback: () => void }): JSX.Element => {
  const [dismissed, setDismissed] = useState(false)
  const dismissHandler = useCallback(() => {
    JSONFetcher.post({ url: dismissPath })
    setDismissed(true)
    dismissCallback()
  }, [dismissPath, dismissCallback])

  return (
    <div className={`bg-gray-200 p-4 pr-9 rounded mb-4 relative ${dismissed ? 'hidden' : ''}`}>
      <TrustedHtml as="p" value={message} />
      <a href={ctaPath} className="btn btn-primary">
        {ctaText}
      </a>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={dismissHandler}
        className="absolute top-4 right-4 simulated-link text-gray-900 hover:text-red-700 focus:text-red-700 active:text-red-700 hover:no-underline"
      >
        <i className="fa fa-times -mt-005"></i>
      </button>
    </div>
  )
}
